import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { ICivilJudgement } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementCivilContainer } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/styled-components';
import { Grid } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import {
  CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE,
  CIVIL_JUDGEMENT_MECHANICAL_EXPERTISE,
  CIVIL_JUDGEMENT_MEDICAL_EXPERTISE,
  COMPTABLE_EXPERTISE_ID,
  JUDGEMENT_EXPERTISE_TYPES,
  MECHANICAL_EXPERTISE_ID,
  MEDICAL_EXPERTISE_ID,
  MODE_TYPES,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { get, isEmpty } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import ContestationDialog from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/ContestationDialog';
import { Listings } from 'containers/AppContainer/typings';
import {
  filterAccountingCivilProceedings,
  getMedicalCivjvm,
  getCivilJudgementMotifs,
  getCivjvmRequestWithExpertise,
  getNewCivjvmWithExpertise,
  getNewCivjWithExpertise,
  hasAccountingExpertise,
  shouldDisplayExpertiseType,
  showAccountingBloc,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { EXPERTISES, LISTINGS } from 'containers/data-structure';
import { IJudgementContestation } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import JudgementOnMeritsMotifRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementOnMeritsMotifRecap';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';
import CivilJudgementRecapByType from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/CivilJudgementRecapVictim';
import { CIVIL_JUDGEMENT_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/constants';
import JudgementForNonCompensation from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/JudgementForNonCompensation';
import InjuredVictimsRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/InjuredVictimsRecap';
import CivilJudgementRecapVehicle from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/CivilJudgementRecapVehicle';
import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import NonCompensationVehiclesRecap from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/NonCompensationVehiclesRecap';

export interface CivilJudgementRecapProps {
  intl: IntlShape;
  listings: Listings;
  setContestationReasons: Function;
  contestationReasons: Set<{
    civilJudgementMedicalExpertiseId: number;
    civilJudgementMechanicalExpertiseId: number;
    civilJudgementAccountingExpertiseId: number;
    contestationReasons: Set<number>;
  }>;
  civilJudgement: ICivilJudgement;
  setCivilJudgements: Function;
  civilJudgements: any;
  isManager?: boolean;
  isContested?: boolean;
  dahirAmount?: any;
  responsabilityShareValue?: string;
  handleCivilResponsabilityShareChange?: any;
  medicalExpertise?: any;
  handleMedExpertiseChange?: any;
  accountingExpertise?: any;
  handleAccExpertiseChange?: any;
  civilJudgementMechanicalExpertise?: any;
  handleMechanicalExpertiseChange?: any;
  isAppeal?: boolean;
  isRejected?: boolean;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  judgementOnMeritsRequest: any;
  setJudgementOnMeritsRequest: Function;
  judgement: any;
  setJudgement: Function;
  civjvmRequest: any;
  judgementOnMerits: any;
  handleCivJvmChange: Function;
  civilJudgementOnMeritsFormAccountingExpertise: any;
  civilJudgementOnMeritsFormMedicalExpertise: any;
  setCivilJudgementOnMeritsFormAccountingExpertise: Function;
  setCivilJudgementOnMeritsFormMedicalExpertise: Function;
  civilJudgementOnMeritsFormMechanicalExpertise: any;
  setCivilJudgementOnMeritsFormMechanicalExpertise: any;
  handleCivjVehicleChange: Function;
  setCivjvmRequest: Function;
  judgementAddDocument: any;
  expertiseReport: any;
  judgementAddDocuments: any;
}
const CivilJudgementRecap: React.FC<CivilJudgementRecapProps> = ({
  listings,
  setContestationReasons,
  contestationReasons,
  civilJudgement,
  isManager,
  isContested: isJudgementOnMeritsContested,
  dahirAmount,
  responsabilityShareValue,
  handleCivilResponsabilityShareChange,
  medicalExpertise,
  handleMedExpertiseChange,
  accountingExpertise,
  handleAccExpertiseChange,
  civilJudgementMechanicalExpertise,
  handleMechanicalExpertiseChange,
  isAppeal,
  isRejected,
  ...props
}): JSX.Element => {
  const medicalExpertisesIds = [
    ...props.civilJudgements
      .flatMap((item: any) => item.civjmede)
      .map((v: any) => v?.victimId),
    ...getMedicalCivjvm(props.civjvmRequest, props.judgementAddDocuments),
  ];
  const accountingExp = props.judgementAddDocuments
    .flatMap((item: any) => item.expertises)
    .filter((item: any) => String(item.expertiseId) === COMPTABLE_EXPERTISE_ID);

  const recentAccountingExpertises = accountingExp
    .flatMap((item: any) => get(item, 'victims', []))
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    );
  const recentAccountingVehiculesExpertises = accountingExp
    .flatMap((item: any) => get(item, 'vehicules', []))
    .sort(
      (a: any, b: any) =>
        new Date(get(a, 'createdAt')).getTime() -
        new Date(get(b, 'createdAt')).getTime(),
    );

  const mechanicalExpertisesIds = props.civilJudgements
    .flatMap((item: any) => item.civjmece)
    .map((v: any) => v?.vehiculeId);
  const [isContestationDialogOpen, setIsContestationDialogOpen] = useState<
    boolean
  >(false);
  const [
    civilJudgementMedicalExpertiseId,
    setCivilJudgementMedicalExpertiseId,
  ] = useState<number | undefined>(undefined);
  const [
    civilJudgementMechanicalExpertiseId,
    setCivilJudgementMechanicalExpertiseId,
  ] = useState<number | undefined>(undefined);
  const [
    civilJudgementAccountingExpertiseId,
    setCivilJudgementAccountingExpertiseId,
  ] = useState<number | undefined>(undefined);

  const [expertiseType, setExpertiseType] = useState<string>('');
  const accountingExpertises = shouldDisplayExpertiseType(
    COMPTABLE_EXPERTISE_ID,
    get(props.judgementAddDocument, 'expertises', []),
  );

  const medicalExpertises = shouldDisplayExpertiseType(
    MEDICAL_EXPERTISE_ID,
    get(props.judgementAddDocument, 'expertises', []),
  );

  const mechanicalExpertises = shouldDisplayExpertiseType(
    MECHANICAL_EXPERTISE_ID,
    get(props.judgementAddDocument, 'expertises', []),
  );

  /* istanbul ignore next */
  const handleOpenContestation = (
    id: number | undefined,
    expertiseType: string,
  ) => () => {
    setExpertiseType(expertiseType);
    switch (expertiseType) {
      case MEDICAL_EXPERTISE_ID:
        setCivilJudgementMedicalExpertiseId(id);
        break;
      case COMPTABLE_EXPERTISE_ID:
        setCivilJudgementAccountingExpertiseId(id);
        break;
      case MECHANICAL_EXPERTISE_ID:
        setCivilJudgementMechanicalExpertiseId(id);
        break;
    }
    setIsContestationDialogOpen(true);
  };
  const isContested = (id: number, expertiseType: string) => {
    for (let item of contestationReasons) {
      if (expertiseType === MEDICAL_EXPERTISE_ID) {
        if (item.civilJudgementMedicalExpertiseId === id) return true;
      }
      if (expertiseType === COMPTABLE_EXPERTISE_ID) {
        if (item.civilJudgementAccountingExpertiseId === id) return true;
      }
      if (expertiseType === MECHANICAL_EXPERTISE_ID) {
        if (item.civilJudgementMechanicalExpertiseId === id) return true;
      }
    }
    return false;
  };
  return (
    <JudgementCivilContainer>
      {(!isEmpty(civilJudgement[CIVIL_JUDGEMENT_MECHANICAL_EXPERTISE]) ||
        !isEmpty(mechanicalExpertises)) && (
        <div className="expertise">
          <div className="expertise-title">
            {translate(messages.mechanicalExpertise, props)}
          </div>

          {civilJudgement[CIVIL_JUDGEMENT_MECHANICAL_EXPERTISE].filter(
            item => item.id,
          ).map((civjmece: any) => {
            const motifListMechanicalExpertise = [
              ...getCivilJudgementMotifs(
                (civjmece.contest as unknown) as IJudgementContestation[],
                get(
                  listings,
                  LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                  [],
                ),
              ),
            ];
            motifListMechanicalExpertise.pop();

            return (
              <>
                <div key={civjmece.id} className="victims">
                  <Grid container>
                    <Grid item xs={10}>
                      <Grid container spacing={2}>
                        {!isEmpty(get(civjmece, 'vehicule')) && (
                          <>
                            <div className="victim-item">{`${get(
                              civjmece,
                              'vehicule.registrationNumber',
                              '',
                            )}`}</div>
                            <div className="text-field-amount">
                              {featureService.hasFeature(
                                FEATURES.REASONS_FOR_NON_COMPENSATION,
                              ) ? (
                                <JudgementForNonCompensation
                                  isRejected={isRejected}
                                  listings={listings}
                                  isContested={isJudgementOnMeritsContested}
                                  dahirAmount={dahirAmount}
                                  expertises={get(
                                    civilJudgementMechanicalExpertise,
                                    'mechanicalExpertise',
                                    [],
                                  )}
                                  handleExpertiseChange={
                                    handleMechanicalExpertiseChange
                                  }
                                  handleOpenContestation={
                                    handleOpenContestation
                                  }
                                  judgementOnMeritsRequest={
                                    props.judgementOnMeritsRequest
                                  }
                                  setJudgementOnMeritsRequest={
                                    props.setJudgementOnMeritsRequest
                                  }
                                  civilJudgementType={
                                    CIVIL_JUDGEMENT_TYPES.MECHANICAL
                                  }
                                  civj={civjmece.id ? civjmece : {}}
                                  isManager={isManager}
                                  vehicle={get(civjmece, 'vehicule', {})}
                                  modeType={MODE_TYPES.RECAP}
                                  judgement={props.judgement}
                                  setJudgement={props.setJudgement}
                                  expertiseJudgementAddDocumentId={get(
                                    civjmece,
                                    'expertiseJudgmentAddDocumentId',
                                    [],
                                  )}
                                  expertiseType={
                                    EXPERTISES.MECHANICAL_EXPERTISE
                                  }
                                  judgementForNonCompensation={
                                    JUDGEMENT_EXPERTISE_TYPES.CIVIL
                                  }
                                  handleCivJvmChange={
                                    props.handleCivjVehicleChange
                                  }
                                  judgementOnMerits={props.judgementOnMerits}
                                  setCivilJudgementUpdateExpertise={
                                    props.setCivilJudgementOnMeritsFormMechanicalExpertise
                                  }
                                  civilJudgementUpdateExpertise={
                                    props.civilJudgementOnMeritsFormMechanicalExpertise
                                  }
                                  civjvm={getCivjvmRequestWithExpertise(
                                    get(
                                      props.judgementOnMeritsRequest,
                                      'civjVehicle',
                                      [],
                                    ),
                                    civjmece,
                                    true,
                                  )}
                                  civjWithNonCompensation={getNewCivjvmWithExpertise(
                                    get(
                                      props.judgementOnMeritsRequest,
                                      'civjVehicle',
                                      [],
                                    ),
                                    civjmece,
                                    INCIDENT_TYPE.VEHICLE,
                                  )}
                                  setCivilJudgements={props.setCivilJudgements}
                                  civilJudgements={props.civilJudgements}
                                  civjvmRequest={props.civjvmRequest}
                                  setCivjvmRequest={props.setCivjvmRequest}
                                  isAppeal={isAppeal}
                                  withAccountingExpertise={hasAccountingExpertise(
                                    recentAccountingVehiculesExpertises,
                                    civjmece.vehiculeId,
                                  )}
                                  judgementAddDocExpertises={get(
                                    props.judgementAddDocument,
                                    'expertises',
                                    [],
                                  )}
                                  isDisabled={
                                    (isJudgementOnMeritsContested &&
                                      isManager) ||
                                    (!isManager && !isRejected)
                                  }
                                  setCivilJudgementUpdateAccountingExpertise={
                                    props.setCivilJudgementOnMeritsFormAccountingExpertise
                                  }
                                  civilJudgementUpdateAccountingExpertise={
                                    props.civilJudgementOnMeritsFormAccountingExpertise
                                  }
                                />
                              ) : (
                                <CivilJudgementRecapVehicle
                                  isManager={isManager}
                                  isRejected={isRejected}
                                  listings={listings}
                                  isContested={isJudgementOnMeritsContested}
                                  dahirAmount={dahirAmount}
                                  expertises={get(
                                    civilJudgementMechanicalExpertise,
                                    'mechanicalExpertise',
                                    [],
                                  )}
                                  handleExpertiseChange={
                                    handleMechanicalExpertiseChange
                                  }
                                  handleOpenContestation={
                                    handleOpenContestation
                                  }
                                  judgementOnMeritsRequest={
                                    props.judgementOnMeritsRequest
                                  }
                                  civilJudgementType={
                                    CIVIL_JUDGEMENT_TYPES.MECHANICAL
                                  }
                                  civj={civjmece}
                                  handleCivJvmChange={props.handleCivJvmChange}
                                  judgementOnMerits={props.judgementOnMerits}
                                  sagisVictimInfo={props.sagisVictimInfo}
                                  judgement={props.judgement}
                                  setJudgement={props.setJudgement}
                                  isAppeal={isAppeal}
                                  vehicle={get(civjmece, 'vehicule', {})}
                                />
                              )}
                            </div>
                          </>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={2}>
                      {isManager &&
                        !isJudgementOnMeritsContested &&
                        !isContested(civjmece.id, MECHANICAL_EXPERTISE_ID) && (
                          <PrimaryButton
                            background={BUTTON_COLORS.PRIMARY_BLUE}
                            border={BUTTON_COLORS.PRIMARY_BLUE}
                            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                            title={translate(messages.challenge, props)}
                            onClick={handleOpenContestation(
                              civjmece.id,
                              MECHANICAL_EXPERTISE_ID,
                            )}
                          />
                        )}
                      {isManager &&
                        !isJudgementOnMeritsContested &&
                        isContested(civjmece.id, MECHANICAL_EXPERTISE_ID) && (
                          <PrimaryButton
                            background={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                            border={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                            titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                            title={translate(messages.challenged, props)}
                          />
                        )}
                      {isJudgementOnMeritsContested &&
                        !isEmpty(motifListMechanicalExpertise) && (
                          <JudgementOnMeritsMotifRecap
                            motifs={getCivilJudgementMotifs(
                              (civjmece.contest as unknown) as IJudgementContestation[],
                              get(
                                listings,
                                LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                                [],
                              ),
                            )}
                          />
                        )}
                    </Grid>
                  </Grid>
                </div>
              </>
            );
          })}

          {/* istanbul ignore next */
          featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
            get(props.judgementOnMeritsRequest, 'civjVehicle', [])
              .filter(
                (item: any) =>
                  item?.id &&
                  item?.expertiseJudgementAddDocumentId ===
                    get(
                      mechanicalExpertises,
                      'expertiseJudgementAddDocumentId',
                    ),
              )
              .map((civjvm: any) => {
                return (
                  <NonCompensationVehiclesRecap
                    listings={listings}
                    judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                    isManager={isManager}
                    modeType={MODE_TYPES.RECAP}
                    judgement={props.judgement}
                    setJudgement={props.setJudgement}
                    judgementForNonCompensation={
                      JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
                    }
                    civjvms={civjvm}
                    civjWithNonCompensation={civjvm?.id ? civjvm : {}}
                    handleCivJvmChange={props.handleCivjVehicleChange}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisOpposingParties={props.sagisOpposingParties}
                    vehicle={{
                      id: get(civjvm, 'vehicleId'),
                      ...get(civjvm, 'vehicle', {}),
                    }}
                    expertiseJudgementAddDocumentId={get(
                      civjvm,
                      'expertiseJudgementAddDocumentId',
                    )}
                    expertiseType={EXPERTISES.MECHANICAL_EXPERTISE}
                    civilJudgementType={CIVIL_JUDGEMENT_TYPES.MECHANICAL}
                    civj={getNewCivjWithExpertise(
                      civjvm,
                      civilJudgement[CIVIL_JUDGEMENT_MECHANICAL_EXPERTISE].map(
                        item => ({
                          ...item,
                          civilJudgementId: civilJudgement.id,
                        }),
                      ),
                      INCIDENT_TYPE.VEHICLE,
                    )}
                    setCivilJudgementUpdateExpertise={
                      props.setCivilJudgementOnMeritsFormMechanicalExpertise
                    }
                    civilJudgementUpdateExpertise={
                      props.civilJudgementOnMeritsFormMechanicalExpertise
                    }
                    setJudgementOnMeritsRequest={
                      props.setJudgementOnMeritsRequest
                    }
                    civjvmRequest={props.civjvmRequest}
                    setCivjvmRequest={props.setCivjvmRequest}
                    expertises={get(
                      civilJudgementMechanicalExpertise,
                      'mechanicalExpertise',
                      [],
                    )}
                    handleExpertiseChange={handleMechanicalExpertiseChange}
                    setCivilJudgements={props.setCivilJudgements}
                    civilJudgements={props.civilJudgements}
                    judgementAddDocExpertises={get(
                      props.judgementAddDocument,
                      'expertises',
                      [],
                    )}
                    setCivilJudgementUpdateAccountingExpertise={
                      props.setCivilJudgementOnMeritsFormAccountingExpertise
                    }
                    civilJudgementUpdateAccountingExpertise={
                      props.civilJudgementOnMeritsFormAccountingExpertise
                    }
                    isDisabled={
                      (isJudgementOnMeritsContested && isManager) ||
                      (!isManager && !isRejected)
                    }
                    isRejected={isRejected}
                  />
                );
              })}
        </div>
      )}
      {(!isEmpty(civilJudgement[CIVIL_JUDGEMENT_MEDICAL_EXPERTISE]) ||
        !isEmpty(medicalExpertises)) && (
        <div className="expertise">
          <div className="expertise-title">
            {translate(messages.medicalExpertise, props)}
          </div>
          {civilJudgement[CIVIL_JUDGEMENT_MEDICAL_EXPERTISE].filter(
            item => item.id,
          ).map((victim: any) => {
            const motifListMedicalExpertise = [
              ...getCivilJudgementMotifs(
                (victim.contest as unknown) as IJudgementContestation[],
                get(
                  listings,
                  LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                  [],
                ),
              ),
            ];
            motifListMedicalExpertise.pop();
            return (
              <div key={victim.id} className="victims">
                <Grid container>
                  <div className="victim-item">
                    {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO)
                      ? `${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victim.victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimFirstName',
                          '',
                        )} ${get(
                          getVictimFromSagisInfo(
                            get(victim, 'victim.victimKey'),
                            props.sagisVictimInfo,
                          ),
                          'victimLastName',
                          '',
                        )}`
                      : `${victim.victim.firstName} ${victim.victim.lastName}`}
                  </div>
                  {featureService.hasFeature(
                    FEATURES.REASONS_FOR_NON_COMPENSATION,
                  ) ? (
                    <JudgementForNonCompensation
                      isRejected={isRejected}
                      listings={listings}
                      isContested={isJudgementOnMeritsContested}
                      dahirAmount={dahirAmount}
                      expertises={get(medicalExpertise, 'medExpertises', [])}
                      handleExpertiseChange={handleMedExpertiseChange}
                      handleOpenContestation={handleOpenContestation}
                      judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                      setJudgementOnMeritsRequest={
                        props.setJudgementOnMeritsRequest
                      }
                      civilJudgementType={CIVIL_JUDGEMENT_TYPES.MEDICAL}
                      civj={victim.id ? victim : {}}
                      motifListExpertise={motifListMedicalExpertise}
                      isManager={isManager}
                      victim={get(victim, 'victim', {})}
                      modeType={MODE_TYPES.RECAP}
                      judgement={props.judgement}
                      setJudgement={props.setJudgement}
                      expertiseJudgementAddDocumentId={get(
                        victim,
                        'expertiseJudgementAddDocumentId',
                      )}
                      expertiseType={EXPERTISES.MEDICAL_EXPERTISE}
                      judgementForNonCompensation={
                        JUDGEMENT_EXPERTISE_TYPES.CIVIL
                      }
                      civjvm={getCivjvmRequestWithExpertise(
                        props.civjvmRequest,
                        victim,
                        true,
                      )}
                      civjWithNonCompensation={getNewCivjvmWithExpertise(
                        props.civjvmRequest,
                        victim,
                        INCIDENT_TYPE.VICTIM,
                      )}
                      handleCivJvmChange={props.handleCivJvmChange}
                      judgementOnMerits={props.judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      setCivilJudgementUpdateExpertise={
                        props.setCivilJudgementOnMeritsFormMedicalExpertise
                      }
                      civilJudgementUpdateExpertise={
                        props.civilJudgementOnMeritsFormMedicalExpertise
                      }
                      setCivilJudgementUpdateAccountingExpertise={
                        props.setCivilJudgementOnMeritsFormAccountingExpertise
                      }
                      civilJudgementUpdateAccountingExpertise={
                        props.civilJudgementOnMeritsFormAccountingExpertise
                      }
                      setCivilJudgements={props.setCivilJudgements}
                      civilJudgements={props.civilJudgements}
                      civjvmRequest={props.civjvmRequest}
                      setCivjvmRequest={props.setCivjvmRequest}
                      isAppeal={isAppeal}
                      withAccountingExpertise={hasAccountingExpertise(
                        recentAccountingExpertises,
                        victim?.victimId,
                      )}
                      judgementAddDocExpertises={get(
                        props.judgementAddDocument,
                        'expertises',
                        [],
                      )}
                      isDisabled={
                        (isJudgementOnMeritsContested && isManager) ||
                        (!isManager && !isRejected)
                      }
                    />
                  ) : (
                    <CivilJudgementRecapByType
                      isManager={isManager}
                      isRejected={isRejected}
                      listings={listings}
                      isContested={isJudgementOnMeritsContested}
                      dahirAmount={dahirAmount}
                      expertises={get(medicalExpertise, 'medExpertises', [])}
                      handleExpertiseChange={handleMedExpertiseChange}
                      handleOpenContestation={handleOpenContestation}
                      judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                      civilJudgementType={CIVIL_JUDGEMENT_TYPES.MEDICAL}
                      civj={victim}
                      motifListExpertise={motifListMedicalExpertise}
                      handleCivJvmChange={props.handleCivJvmChange}
                      judgementOnMerits={props.judgementOnMerits}
                      sagisVictimInfo={props.sagisVictimInfo}
                      judgement={props.judgement}
                      setJudgement={props.setJudgement}
                      isAppeal={isAppeal}
                      victim={get(victim, 'victim', {})}
                    />
                  )}
                </Grid>
                {isManager &&
                  !isJudgementOnMeritsContested &&
                  !isContested(victim.id, MEDICAL_EXPERTISE_ID) && (
                    <PrimaryButton
                      background={BUTTON_COLORS.PRIMARY_BLUE}
                      border={BUTTON_COLORS.PRIMARY_BLUE}
                      titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                      title={translate(messages.challenge, props)}
                      onClick={handleOpenContestation(
                        victim.id,
                        MEDICAL_EXPERTISE_ID,
                      )}
                    />
                  )}
                {isManager &&
                  !isJudgementOnMeritsContested &&
                  isContested(victim.id, MEDICAL_EXPERTISE_ID) && (
                    <PrimaryButton
                      background={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                      border={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                      titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                      title={translate(messages.challenged, props)}
                    />
                  )}
                {isJudgementOnMeritsContested &&
                  !isEmpty(motifListMedicalExpertise) && (
                    <JudgementOnMeritsMotifRecap
                      motifs={getCivilJudgementMotifs(
                        (victim.contest as unknown) as IJudgementContestation[],
                        get(
                          listings,
                          LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                          [],
                        ),
                      )}
                    />
                  )}
                <div className="caduc-position">
                  {get(victim, 'isOld') && (
                    <article className="caduc-item">
                      {translate(messages.caduc, props)}
                    </article>
                  )}
                </div>
              </div>
            );
          })}
          {/* istanbul ignore next */
          featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
            props.civjvmRequest
              .filter(
                (item: any) =>
                  item?.id &&
                  item?.expertiseJudgementAddDocumentId ===
                    get(medicalExpertises, 'expertiseJudgementAddDocumentId'),
              )
              .map((civjvm: any) => {
                return (
                  <InjuredVictimsRecap
                    listings={listings}
                    judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                    isManager={isManager}
                    modeType={MODE_TYPES.RECAP}
                    judgement={props.judgement}
                    setJudgement={props.setJudgement}
                    judgementForNonCompensation={
                      JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
                    }
                    civjvms={civjvm}
                    civjWithNonCompensation={civjvm?.id ? civjvm : {}}
                    handleCivJvmChange={props.handleCivJvmChange}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisVictimInfo={props.sagisVictimInfo}
                    victim={{
                      id: get(civjvm, 'victimId'),
                      ...get(civjvm, 'victim', {}),
                    }}
                    expertiseJudgementAddDocumentId={get(
                      civjvm,
                      'expertiseJudgementAddDocumentId',
                    )}
                    expertiseType={EXPERTISES.MEDICAL_EXPERTISE}
                    civilJudgementType={CIVIL_JUDGEMENT_TYPES.MEDICAL}
                    civj={getNewCivjWithExpertise(
                      civjvm,
                      civilJudgement[CIVIL_JUDGEMENT_MEDICAL_EXPERTISE].map(
                        item => ({
                          ...item,
                          civilJudgementId: civilJudgement.id,
                        }),
                      ),
                      INCIDENT_TYPE.VICTIM,
                    )}
                    setCivilJudgementUpdateExpertise={
                      props.setCivilJudgementOnMeritsFormMedicalExpertise
                    }
                    civilJudgementUpdateExpertise={
                      props.civilJudgementOnMeritsFormMedicalExpertise
                    }
                    setJudgementOnMeritsRequest={
                      props.setJudgementOnMeritsRequest
                    }
                    civjvmRequest={props.civjvmRequest}
                    setCivjvmRequest={props.setCivjvmRequest}
                    expertises={get(medicalExpertise, 'medExpertises', [])}
                    handleExpertiseChange={handleMedExpertiseChange}
                    setCivilJudgements={props.setCivilJudgements}
                    civilJudgements={props.civilJudgements}
                    isAppeal={isAppeal}
                    withAccountingExpertise={hasAccountingExpertise(
                      recentAccountingExpertises,
                      get(civjvm, 'victimId'),
                    )}
                    setCivilJudgementUpdateAccountingExpertise={
                      props.setCivilJudgementOnMeritsFormAccountingExpertise
                    }
                    civilJudgementUpdateAccountingExpertise={
                      props.civilJudgementOnMeritsFormAccountingExpertise
                    }
                    judgementAddDocExpertises={get(
                      props.judgementAddDocument,
                      'expertises',
                      [],
                    )}
                    isDisabled={
                      (isJudgementOnMeritsContested && isManager) ||
                      (!isManager && !isRejected)
                    }
                    isRejected={isRejected}
                    dahirAmount={dahirAmount}
                  />
                );
              })}
        </div>
      )}
      {showAccountingBloc(
        civilJudgement,
        accountingExpertises,
        medicalExpertisesIds,
        mechanicalExpertisesIds,
        props.judgementOnMeritsRequest,
        props.civjvmRequest,
      ) && (
        <div className="expertise">
          <div className="expertise-title">
            {translate(messages.accountingExpertise, props)}
          </div>
          {filterAccountingCivilProceedings(
            civilJudgement[CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE].filter(
              item => item.id,
            ),
            medicalExpertisesIds,
            mechanicalExpertisesIds,
          ).map((civjacce: any) => {
            const motifListAccountingExpertise = [
              ...getCivilJudgementMotifs(
                (civjacce.contest as unknown) as IJudgementContestation[],
                get(
                  listings,
                  LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                  [],
                ),
              ),
            ];
            motifListAccountingExpertise.pop();
            return (
              <div key={civjacce.id} className="victims">
                <Grid container>
                  <Grid item xs={10}>
                    {!isEmpty(get(civjacce, 'victim')) && (
                      <Grid container>
                        <div className="victim-item">
                          {featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          )
                            ? `${get(
                                getVictimFromSagisInfo(
                                  get(civjacce, 'victim.victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimFirstName',
                                '',
                              )} ${get(
                                getVictimFromSagisInfo(
                                  get(civjacce, 'victim.victimKey'),
                                  props.sagisVictimInfo,
                                ),
                                'victimLastName',
                                '',
                              )}`
                            : `${get(civjacce, 'victim.firstName', '')} ${get(
                                civjacce,
                                'victim.lastName',
                                '',
                              )}`}
                        </div>

                        {featureService.hasFeature(
                          FEATURES.REASONS_FOR_NON_COMPENSATION,
                        ) ? (
                          <>
                            <JudgementForNonCompensation
                              isRejected={isRejected}
                              listings={listings}
                              isContested={isJudgementOnMeritsContested}
                              dahirAmount={dahirAmount}
                              expertises={get(
                                accountingExpertise,
                                'accExpertises',
                                [],
                              )}
                              handleExpertiseChange={handleAccExpertiseChange}
                              handleOpenContestation={handleOpenContestation}
                              judgementOnMeritsRequest={
                                props.judgementOnMeritsRequest
                              }
                              setJudgementOnMeritsRequest={
                                props.setJudgementOnMeritsRequest
                              }
                              civilJudgementType={
                                CIVIL_JUDGEMENT_TYPES.ACCOUNTING
                              }
                              civj={civjacce.id ? civjacce : {}}
                              motifListExpertise={motifListAccountingExpertise}
                              isManager={isManager}
                              victim={get(civjacce, 'victim', {})}
                              modeType={MODE_TYPES.RECAP}
                              judgement={props.judgement}
                              setJudgement={props.setJudgement}
                              expertiseJudgementAddDocumentId={get(
                                civjacce,
                                'expertiseJudgementAddDocumentId',
                              )}
                              expertiseType={EXPERTISES.ACCOUNTING_EXPERTISE}
                              judgementForNonCompensation={
                                JUDGEMENT_EXPERTISE_TYPES.CIVIL
                              }
                              civjvm={getCivjvmRequestWithExpertise(
                                props.civjvmRequest,
                                civjacce,
                                true,
                              )}
                              civjWithNonCompensation={getNewCivjvmWithExpertise(
                                props.civjvmRequest,
                                civjacce,
                                INCIDENT_TYPE.VICTIM,
                              )}
                              handleCivJvmChange={props.handleCivJvmChange}
                              judgementOnMerits={props.judgementOnMerits}
                              sagisVictimInfo={props.sagisVictimInfo}
                              setCivilJudgementUpdateExpertise={
                                props.setCivilJudgementOnMeritsFormAccountingExpertise
                              }
                              setCivilJudgements={props.setCivilJudgements}
                              civilJudgements={props.civilJudgements}
                              civilJudgementUpdateExpertise={
                                props.civilJudgementOnMeritsFormAccountingExpertise
                              }
                              civjvmRequest={props.civjvmRequest}
                              setCivjvmRequest={props.setCivjvmRequest}
                              isAppeal={isAppeal}
                              withAccountingExpertise={hasAccountingExpertise(
                                recentAccountingExpertises,
                                civjacce?.victimId,
                              )}
                              judgementAddDocExpertises={get(
                                props.judgementAddDocument,
                                'expertises',
                                [],
                              )}
                              isDisabled={
                                (isJudgementOnMeritsContested && isManager) ||
                                (!isManager && !isRejected)
                              }
                            />
                          </>
                        ) : (
                          <CivilJudgementRecapByType
                            isManager={isManager}
                            isRejected={isRejected}
                            listings={listings}
                            isContested={isJudgementOnMeritsContested}
                            dahirAmount={dahirAmount}
                            expertises={get(
                              accountingExpertise,
                              'accExpertises',
                              [],
                            )}
                            handleExpertiseChange={handleAccExpertiseChange}
                            handleOpenContestation={handleOpenContestation}
                            judgementOnMeritsRequest={
                              props.judgementOnMeritsRequest
                            }
                            civilJudgementType={
                              CIVIL_JUDGEMENT_TYPES.ACCOUNTING
                            }
                            sagisVictimInfo={props.sagisVictimInfo}
                            civj={civjacce}
                            motifListExpertise={motifListAccountingExpertise}
                            handleCivJvmChange={props.handleCivJvmChange}
                            judgementOnMerits={props.judgementOnMerits}
                            judgement={props.judgement}
                            setJudgement={props.setJudgement}
                            isAppeal={isAppeal}
                            victim={get(civjacce, 'victim', {})}
                          />
                        )}
                      </Grid>
                    )}
                    {!isEmpty(get(civjacce, 'vehicule')) && !!civjacce.id && (
                      <Grid container>
                        <div className="victim-item">
                          {featureService.hasFeature(
                            FEATURES.MIGRATION_CLAIM_INFO,
                          ) &&
                          !isEmpty(
                            getVehicleFromSagisInfo(
                              get(civjacce, 'vehicule.partKey', ''),
                              props.sagisOpposingParties,
                            ),
                          )
                            ? get(
                                getVehicleFromSagisInfo(
                                  get(civjacce, 'vehicule.partKey', ''),
                                  props.sagisOpposingParties,
                                ),
                                'registrationNumber',
                              )
                            : `${get(
                                civjacce,
                                'vehicule.registrationNumber',
                                '',
                              )}`}
                        </div>
                        {featureService.hasFeature(
                          FEATURES.REASONS_FOR_NON_COMPENSATION,
                        ) ? (
                          <>
                            <JudgementForNonCompensation
                              isRejected={isRejected}
                              listings={listings}
                              isContested={isJudgementOnMeritsContested}
                              expertises={get(
                                accountingExpertise,
                                'accExpertises',
                                [],
                              )}
                              handleExpertiseChange={handleAccExpertiseChange}
                              handleOpenContestation={handleOpenContestation}
                              judgementOnMeritsRequest={
                                props.judgementOnMeritsRequest
                              }
                              setJudgementOnMeritsRequest={
                                props.setJudgementOnMeritsRequest
                              }
                              civilJudgementType={
                                CIVIL_JUDGEMENT_TYPES.ACCOUNTING
                              }
                              civj={civjacce.id ? civjacce : {}}
                              isManager={isManager}
                              vehicle={get(civjacce, 'vehicule', {})}
                              modeType={MODE_TYPES.RECAP}
                              judgement={props.judgement}
                              setJudgement={props.setJudgement}
                              expertiseJudgementAddDocumentId={get(
                                civjacce,
                                'expertiseJudgementAddDocumentId',
                                [],
                              )}
                              expertiseType={EXPERTISES.ACCOUNTING_EXPERTISE}
                              judgementForNonCompensation={
                                JUDGEMENT_EXPERTISE_TYPES.CIVIL
                              }
                              handleCivJvmChange={props.handleCivjVehicleChange}
                              judgementOnMerits={props.judgementOnMerits}
                              setCivilJudgementUpdateExpertise={
                                props.setCivilJudgementOnMeritsFormAccountingExpertise
                              }
                              civilJudgementUpdateExpertise={
                                props.civilJudgementOnMeritsFormAccountingExpertise
                              }
                              civjvm={getCivjvmRequestWithExpertise(
                                get(
                                  props.judgementOnMeritsRequest,
                                  'civjVehicle',
                                  [],
                                ),
                                civjacce,
                                true,
                              )}
                              civjWithNonCompensation={getNewCivjvmWithExpertise(
                                get(
                                  props.judgementOnMeritsRequest,
                                  'civjVehicle',
                                  [],
                                ),
                                civjacce,
                                INCIDENT_TYPE.VEHICLE,
                              )}
                              setCivilJudgements={props.setCivilJudgements}
                              civilJudgements={props.civilJudgements}
                              civjvmRequest={props.civjvmRequest}
                              setCivjvmRequest={props.setCivjvmRequest}
                              isAppeal={isAppeal}
                              withAccountingExpertise={hasAccountingExpertise(
                                recentAccountingVehiculesExpertises,
                                civjacce?.vehiculeId,
                              )}
                              judgementAddDocExpertises={get(
                                props.judgementAddDocument,
                                'expertises',
                                [],
                              )}
                              isDisabled={
                                (isJudgementOnMeritsContested && isManager) ||
                                (!isManager && !isRejected)
                              }
                            />
                          </>
                        ) : (
                          <CivilJudgementRecapVehicle
                            isManager={isManager}
                            isRejected={isRejected}
                            listings={listings}
                            isContested={isJudgementOnMeritsContested}
                            expertises={get(
                              civjacce,
                              'expertiseJudgementAddDocumentId',
                              [],
                            )}
                            handleExpertiseChange={handleAccExpertiseChange}
                            handleOpenContestation={handleOpenContestation}
                            judgementOnMeritsRequest={
                              props.judgementOnMeritsRequest
                            }
                            civilJudgementType={
                              CIVIL_JUDGEMENT_TYPES.ACCOUNTING
                            }
                            civj={civjacce}
                            handleCivJvmChange={props.handleCivJvmChange}
                            judgementOnMerits={props.judgementOnMerits}
                            sagisVictimInfo={props.sagisVictimInfo}
                            judgement={props.judgement}
                            setJudgement={props.setJudgement}
                            isAppeal={isAppeal}
                            vehicle={get(civjacce, 'vehicule', {})}
                          />
                        )}
                      </Grid>
                    )}
                  </Grid>
                  <Grid item xs={2}>
                    {isManager &&
                      !isJudgementOnMeritsContested &&
                      !isContested(civjacce.id, COMPTABLE_EXPERTISE_ID) && (
                        <PrimaryButton
                          background={BUTTON_COLORS.PRIMARY_BLUE}
                          border={BUTTON_COLORS.PRIMARY_BLUE}
                          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                          title={translate(messages.challenge, props)}
                          onClick={handleOpenContestation(
                            civjacce.id,
                            COMPTABLE_EXPERTISE_ID,
                          )}
                        />
                      )}
                    {isManager &&
                      !isJudgementOnMeritsContested &&
                      isContested(civjacce.id, COMPTABLE_EXPERTISE_ID) && (
                        <PrimaryButton
                          background={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                          border={BUTTON_COLORS.GOLDEN_BUTTON_TITLE}
                          titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                          title={translate(messages.challenged, props)}
                        />
                      )}
                    {isJudgementOnMeritsContested &&
                      !isEmpty(motifListAccountingExpertise) && (
                        <JudgementOnMeritsMotifRecap
                          motifs={getCivilJudgementMotifs(
                            (civjacce.contest as unknown) as IJudgementContestation[],
                            get(
                              listings,
                              LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
                              [],
                            ),
                          )}
                        />
                      )}
                    {get(civjacce, 'isOld') && (
                      <article className="caduc-item">
                        {translate(messages.caduc, props)}
                      </article>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          })}
          {/* istanbul ignore next */
          featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
            get(props.judgementOnMeritsRequest, 'civjVehicle', [])
              .filter(
                (item: any) =>
                  item?.id &&
                  item?.expertiseJudgementAddDocumentId ===
                    get(
                      accountingExpertises,
                      'expertiseJudgementAddDocumentId',
                    ) &&
                  !mechanicalExpertisesIds.includes(item?.vehicleId),
              )
              .map((civjvm: any) => {
                return (
                  <NonCompensationVehiclesRecap
                    listings={listings}
                    judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                    isManager={isManager}
                    modeType={MODE_TYPES.RECAP}
                    judgement={props.judgement}
                    setJudgement={props.setJudgement}
                    judgementForNonCompensation={
                      JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
                    }
                    civjvms={civjvm}
                    civjWithNonCompensation={civjvm?.id ? civjvm : {}}
                    handleCivJvmChange={props.handleCivjVehicleChange}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisOpposingParties={props.sagisOpposingParties}
                    vehicle={{
                      id: get(civjvm, 'vehicleId'),
                      ...get(civjvm, 'vehicle', {}),
                    }}
                    expertiseJudgementAddDocumentId={get(
                      civjvm,
                      'expertiseJudgementAddDocumentId',
                    )}
                    expertiseType={EXPERTISES.ACCOUNTING_EXPERTISE}
                    civilJudgementType={CIVIL_JUDGEMENT_TYPES.ACCOUNTING}
                    civj={getNewCivjWithExpertise(
                      civjvm,
                      civilJudgement[CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE].map(
                        item => ({
                          ...item,
                          civilJudgementId: civilJudgement.id,
                        }),
                      ),
                      INCIDENT_TYPE.VEHICLE,
                    )}
                    setCivilJudgementUpdateExpertise={
                      props.setCivilJudgementOnMeritsFormAccountingExpertise
                    }
                    civilJudgementUpdateExpertise={
                      props.civilJudgementOnMeritsFormAccountingExpertise
                    }
                    setJudgementOnMeritsRequest={
                      props.setJudgementOnMeritsRequest
                    }
                    civjvmRequest={props.civjvmRequest}
                    setCivjvmRequest={props.setCivjvmRequest}
                    expertises={get(accountingExpertise, 'accExpertises', [])}
                    handleExpertiseChange={handleAccExpertiseChange}
                    setCivilJudgements={props.setCivilJudgements}
                    civilJudgements={props.civilJudgements}
                    isAppeal={isAppeal}
                    judgementAddDocExpertises={get(
                      props.judgementAddDocument,
                      'expertises',
                      [],
                    )}
                    isDisabled={
                      (isJudgementOnMeritsContested && isManager) ||
                      (!isManager && !isRejected)
                    }
                    isRejected={isRejected}
                  />
                );
              })}

          {/* istanbul ignore next */
          featureService.hasFeature(FEATURES.REASONS_FOR_NON_COMPENSATION) &&
            props.civjvmRequest
              .filter(
                (item: any) =>
                  item?.id &&
                  item?.expertiseJudgementAddDocumentId ===
                    get(
                      accountingExpertises,
                      'expertiseJudgementAddDocumentId',
                    ) &&
                  !medicalExpertisesIds.includes(item?.victimId),
              )
              .map((civjvm: any) => {
                return (
                  <InjuredVictimsRecap
                    listings={listings}
                    judgementOnMeritsRequest={props.judgementOnMeritsRequest}
                    isManager={isManager}
                    modeType={MODE_TYPES.RECAP}
                    judgement={props.judgement}
                    setJudgement={props.setJudgement}
                    judgementForNonCompensation={
                      JUDGEMENT_EXPERTISE_TYPES.CIVIL_AND_NON_COMPENSATION
                    }
                    civjvms={civjvm}
                    civjWithNonCompensation={civjvm?.id ? civjvm : {}}
                    handleCivJvmChange={props.handleCivJvmChange}
                    judgementOnMerits={props.judgementOnMerits}
                    sagisVictimInfo={props.sagisVictimInfo}
                    victim={{
                      id: get(civjvm, 'victimId'),
                      ...get(civjvm, 'victim', {}),
                    }}
                    expertiseJudgementAddDocumentId={get(
                      civjvm,
                      'expertiseJudgementAddDocumentId',
                    )}
                    expertiseType={EXPERTISES.ACCOUNTING_EXPERTISE}
                    civilJudgementType={CIVIL_JUDGEMENT_TYPES.ACCOUNTING}
                    civj={getNewCivjWithExpertise(
                      civjvm,
                      civilJudgement[CIVIL_JUDGEMENT_ACCOUNTING_EXPERTISE].map(
                        item => ({
                          ...item,
                          civilJudgementId: civilJudgement.id,
                        }),
                      ),
                      INCIDENT_TYPE.VICTIM,
                    )}
                    setCivilJudgementUpdateExpertise={
                      props.setCivilJudgementOnMeritsFormAccountingExpertise
                    }
                    civilJudgementUpdateExpertise={
                      props.civilJudgementOnMeritsFormAccountingExpertise
                    }
                    setJudgementOnMeritsRequest={
                      props.setJudgementOnMeritsRequest
                    }
                    civjvmRequest={props.civjvmRequest}
                    setCivjvmRequest={props.setCivjvmRequest}
                    expertises={get(accountingExpertise, 'accExpertises', [])}
                    handleExpertiseChange={handleAccExpertiseChange}
                    setCivilJudgements={props.setCivilJudgements}
                    civilJudgements={props.civilJudgements}
                    isAppeal={isAppeal}
                    withAccountingExpertise={hasAccountingExpertise(
                      recentAccountingExpertises,
                      get(civjvm, 'victimId'),
                    )}
                    judgementAddDocExpertises={get(
                      props.judgementAddDocument,
                      'expertises',
                      [],
                    )}
                    isDisabled={
                      (isJudgementOnMeritsContested && isManager) ||
                      (!isManager && !isRejected)
                    }
                    isRejected={isRejected}
                    dahirAmount={dahirAmount}
                  />
                );
              })}
        </div>
      )}
      <ContestationDialog
        civilJudgementMedicalExpertiseId={civilJudgementMedicalExpertiseId}
        civilJudgementAccountingExpertiseId={
          civilJudgementAccountingExpertiseId
        }
        civilJudgementMechanicalExpertiseId={
          civilJudgementMechanicalExpertiseId
        }
        civilJudgementId={civilJudgement.id}
        expertiseType={expertiseType}
        listings={listings}
        contestationReasons={contestationReasons}
        setContestationReasons={setContestationReasons}
        isOpen={isContestationDialogOpen}
        setIsContestationDialogOpen={setIsContestationDialogOpen}
      />
    </JudgementCivilContainer>
  );
};

export default injectIntl(CivilJudgementRecap);
